// team id -> team name conversion
export const nbaTeams = {
    "ATL": "Hawks",
    "BKN": "Nets",
    "BOS": "Celtics",
    "CHA": "Hornets",
    "CHI": "Bulls",
    "CLE": "Cavaliers",
    "DAL": "Mavericks",
    "DEN": "Nuggets",
    "DET": "Pistons",
    "GS": "Warriors",
    "HOU": "Rockets",
    "IND": "Pacers",
    "LAC": "Clippers",
    "LAL": "Lakers",
    "MEM": "Grizzlies",
    "MIA": "Heat",
    "MIL": "Bucks",
    "MIN": "Timberwolves",
    "NO": "Pelicans",
    "NY": "Knicks",
    "OKC": "Thunder",
    "ORL": "Magic",
    "PHI": "76ers",
    "PHO": "Suns",
    "POR": "Trail Blazers",
    "SA": "Spurs",
    "SAC": "Kings",
    "TOR": "Raptors",
    "UTA": "Jazz",
    "WAS": "Wizards"
}

export const nbaTeamIds = {
    "ATL": 3,
    "BKN": 8,
    "BOS": 9,
    "CHA": 2,
    "CHI": 11,
    "CLE": 12,
    "DAL": 25,
    "DEN": 20,
    "DET": 14,
    "GS": 26,
    "HOU": 22,
    "IND": 13,
    "LAC": 28,
    "LAL": 27,
    "MEM": 21,
    "MIA": 4,
    "MIL": 15,
    "MIN": 16,
    "NO": 23,
    "NY": 6,
    "OKC": 18,
    "ORL": 5,
    "PHI": 7,
    "PHO": 29,
    "POR": 19,
    "SA": 24,
    "SAC": 30,
    "TOR": 10,
    "UTA": 17,
    "WAS": 1
}

export const nbaConferences = {
    "East": ["CLE", "BOS", "NY", "CHA", "BKN",
             "IND", "DET", "ORL", "ATL", "MIA", 
             "CHI", "WAS", "TOR", "MIL", "PHI"],
    "West": ["PHO", "OKC", "GS", "MIN", "DEN",
             "MEM", "HOU", "LAL", "LAC", "DAL",
             "SAC", "SA", "POR", "NO", "UTA"]
};

export const nbaStatVerbs = {
    "off": {
        "stats.Possessions": "are",
        "stats.FieldGoalsMade": "are",
        "stats.FieldGoalsAttempted": "are",
        "stats.TwoPointersMade": "are",
        "stats.TwoPointersAttempted": "are",
        "stats.ThreePointersMade": "are",
        "stats.ThreePointersAttempted": "are",
        "stats.FreeThrowsMade": "are",
        "stats.OffensiveRebounds": "are",
        "stats.Assists": "are",
        "stats.Turnovers": "are",
        "stats.Points": "are",
        "stats.TrueShootingAttempts": "are",
        "stats.DoubleDoubles": "are",
        "stats.TripleDoubles": "are",
        "calculated.FieldGoalPercentage": "is",
        "calculated.TwoPtFgPercentage": "is",
        "calculated.ThreePtFgPercentage": "is",
        "calculated.FtPercentage": "is",
        "calculated.EffectiveFgPercentage": "is",
        "calculated.TrueShootingPercentage": "is",
        "calculated.PtsPerPossession": "is",
        "calculated.FtRate": "is",
        "calculated.ThreePtAttemptRate": "is",
        "calculated.PercentagePtsFromTwo": "is",
        "calculated.PercentagePtsFromThree": "is",
        "calculated.PercentagePtsFromFt": "is",
        "calculated.OffensiveEfficiencyRating": "is",
        "calculated.AssistPercentage": "is"
    },
    "def": {
        "stats.DefensiveRebounds": "are",
        "stats.Steals": "are",
        "stats.BlockedShots": "are",
        "calculated.BlockToFoulRatio": "is",
        "calculated.TurnoverRatio": "is",
        "calculated.TurnoverPercentage": "is"
    },
    "gen": {
        "stats.Rebounds": "are",
        "stats.PersonalFouls": "are",
        "calculated.AssistToTurnoverRatio": "is"
    }
};

export const nbaStats = {
    "off" : {
        "stats.Possessions": "possessions",
        "stats.FieldGoalsMade": "fgs made",
        "stats.FieldGoalsAttempted": "fgs attempted",
        "stats.TwoPointersMade": "two pointers made",
        "stats.TwoPointersAttempted": "two pointers attempted",
        "stats.ThreePointersMade": "three pointers made",
        "stats.ThreePointersAttempted": "three pointers attempted",
        "stats.FreeThrowsMade": "free throws made",
        "stats.OffensiveRebounds": "offensive rebounds",
        "stats.Assists": "assists",
        "stats.Turnovers": "turnovers",
        "stats.Points": "points scored",
        "stats.TrueShootingAttempts": "true shooting attempts",
        "stats.DoubleDoubles": "double doubles",
        "stats.TripleDoubles": "triple doubles",
        "calculated.FieldGoalPercentage": "fg percentage",
        "calculated.TwoPtFgPercentage": "two point fg percentage",
        "calculated.ThreePtFgPercentage": "three point fg percentage",
        "calculated.FtPercentage": "free throw percentage",
        "calculated.EffectiveFgPercentage": "effective fg percentage",
        "calculated.TrueShootingPercentage": "true shooting percentage",
        "calculated.PtsPerPossession": "pts per possession",
        "calculated.FtRate": "free throw rate",
        "calculated.ThreePtAttemptRate": "three pt attempt rate",
        "calculated.PercentagePtsFrom2": "percentage of pts from two",
        "calculated.PercentagePtsFrom3": "percentage of pts from three",
        "calculated.PercentagePtsFromFt": "percentage of pts from free throws",
        "calculated.OffensiveEfficiencyRating": "offensive efficiency rating",
        "calculated.AssistPercentage": "assist percentage",
        "calculated.AssistToTurnoverRatio": "assist to turnover ratio",
        "calculated.TurnoverRate": "turnover ratio",
        "calculated.TurnoverPercentage": "turnover percentage"
    },
    "def": {
        "stats.DefensiveRebounds": "defensive rebounds",
        "stats.Steals": "steals",
        "stats.BlockedShots": "blocked shots",
        "calculated.BlockToFoulRatio": "block to foul ratio",
    },
    "gen": {
        "stats.Rebounds": "total rebounds",
        "stats.PersonalFouls": "personal fouls",
    }
};

export const higherIsBetter = {
    "stats.Possessions": true,
    "stats.FieldGoalsMade": true,
    "stats.FieldGoalsAttempted": true,
    "stats.TwoPointersMade": true,
    "stats.TwoPointersAttempted": true,
    "stats.ThreePointersMade": true,
    "stats.ThreePointersAttempted": true,
    "stats.FreeThrowsMade": true,
    "stats.OffensiveRebounds": true,
    "stats.Assists": true,
    "stats.Turnovers": false,
    "stats.Points": true,
    "stats.TrueShootingAttempts": true,
    "stats.DoubleDoubles": true,
    "stats.TripleDoubles": true,
    "calculated.FieldGoalPercentage": true,
    "calculated.TwoPtFgPercentage": true,
    "calculated.ThreePtFgPercentage": true,
    "calculated.FtPercentage": true,
    "calculated.EffectiveFgPercentage": true,
    "calculated.TrueShootingPercentage": true,
    "calculated.PtsPerPossession": true,
    "calculated.FtRate": true,
    "calculated.ThreePtAttemptRate": true,
    "calculated.PercentagePtsFrom2": true,
    "calculated.PercentagePtsFrom3": true,
    "calculated.PercentagePtsFromFt": true,
    "calculated.OffensiveEfficiencyRating": true,
    "calculated.AssistPercentage": true,
    "calculated.AssistToTurnoverRatio": true,
    "calculated.TurnoverRate": false,
    "calculated.TurnoverPercentage": false,
    "stats.DefensiveRebounds": true,
    "stats.Steals": true,
    "stats.BlockedShots": true,
    "calculated.BlockToFoulRatio": true,
    "stats.Rebounds": true,
    "stats.PersonalFouls": false,
    "stats.Minutes": true,
    "stats.Points1Q": true,
    "stats.Points2Q": true,
    "stats.Points3Q": true,
    "stats.Points4Q": true,
    "stats.Points1H": true,
    "stats.Points2H": true,
    "stats.OppPoints1Q": false,
    "stats.OppPoints2Q": false,
    "stats.OppPoints3Q": false,
    "stats.OppPoints4Q": false,
    "stats.OppPoints1H": false,
    "stats.OppPoints2H": false,
    "stats.OppPossessions": false, 
    "stats.OppFantasyPoints": false,
    "stats.OppFieldGoalsMade": false,
    "stats.OppFieldGoalsAttempted": false,
    "stats.OppTwoPointersMade": false,
    "stats.OppTwoPointersAttempted": false,
    "stats.OppThreePointersMade": false,
    "stats.OppThreePointersAttempted": false,
    "stats.OppFreeThrowsMade": false,
    "stats.OppFreeThrowsAttempted": false,
    "stats.OppOffensiveRebounds": false,
    "stats.OppDefensiveRebounds": false,
    "stats.OppRebounds": false,
    "stats.OppAssists": false,
    "stats.OppSteals": false,
    "stats.OppBlockedShots": false,
    "stats.OppTurnovers": true,
    "stats.OppPersonalFouls": true,
    "stats.OppPoints": false,
    "stats.OppTrueShootingAttempts": false,
    "stats.OppDoubleDoubles": false,
    "stats.OppTripleDoubles": false,
    "calculated.Pace": true,
    "calculated.DefensiveRating": false,
    "calculated.NetRating": true,
    "calculated.OffReboundPercentage": true,
    "calculated.DefReboundPercentage": true,
    "calculated.TotalReboundPercentage": true,
    "calculated.Points1QPercentage": true,
    "calculated.Points2QPercentage": true,
    "calculated.Points3QPercentage": true,
    "calculated.Points4QPercentage": true,
    "calculated.Points1HPercentage": true,
    "calculated.Points2HPercentage": true,
    "calculated.OppPoints1QPercentage": false,
    "calculated.OppPoints2QPercentage": false,
    "calculated.OppPoints3QPercentage": false,
    "calculated.OppPoints4QPercentage": false,
    "calculated.OppPoints1HPercentage": false,
    "calculated.OppPoints2HPercentage": false,
    "calculated.OppFieldGoalPercentage": false,
    "calculated.OppTwoPtFgPercentage": false,
    "calculated.OppThreePtFgPercentage": false,
    "calculated.OppFtPercentage": false,
    "calculated.OppEffectiveFgPercentage": false,
    "calculated.OppTrueShootingPercentage": false,
    "calculated.OppAssistToTurnoverRatio": false,
    "calculated.OppPtsPerPossession": false,
    "calculated.OppTurnoverPercentage": true,
    "calculated.OppFtRate": false,
    "calculated.OppThreePtAttemptRate": false,
    "calculated.OppPercentagePtsFrom2": false,
    "calculated.OppPercentagePtsFrom3": false,
    "calculated.OppPercentagePtsFromFt": false,
    "calculated.OppAssistPercentage": false,
    "calculated.OppTurnoverRate": true,
    "calculated.OppBlockToFoulRatio": false
};